// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.core

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.*
import io.github.erkko68.kolt.physics.collision.broadphase.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/**
 * Implementation of the Barrier class for a JobSystem
 *
 * This class can be used to make it easier to create a new JobSystem implementation that integrates with your own job system.
 * It will implement all functionality relating to barriers, so the only functions that are left to be implemented are:
 *
 * * JobSystem::GetMaxConcurrency
 * * JobSystem::CreateJob
 * * JobSystem::FreeJob
 * * JobSystem::QueueJob/QueueJobs
 *
 * See instructions in JobSystem for more information on how to implement these.
 *
 * C++ `JPH::JobSystemWithBarrier`.
 */
open class JobSystemWithBarrier internal constructor(internal val jobSystemWithBarrierHandle: NativePointer, owned: Boolean = false) : JobSystem(JphJobSystemWithBarrier_asJobSystem(jobSystemWithBarrierHandle), owned), AutoCloseable {
    override fun close() =
        closeOnce { JphJobSystemWithBarrier_destroy(jobSystemWithBarrierHandle) }

    /**
     * Initialize the barriers
     * @param maxBarriers Max number of barriers that can be allocated at any time
     */
    fun init(maxBarriers: Int) =
        JphJobSystemWithBarrier_Init(jobSystemWithBarrierHandle, maxBarriers)
}
